{"sidebar.collapseSidebar":"Collapse Sidebar","sidebar.expandSidebar":"Expand Sidebar"}